/*
 * @Descripttion: echart
 * @Author: zenghua.wang
 * @Date: 2021-08-25 09:08:23
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 16:49:25
 */

import lodash from 'lodash'
import {
  isEmpty,
  setPx,
  fixChromeZoom,
  getTextByAnalysis
} from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    apiId: {
      type: [Number, String]
    },
    width: {
      type: [Number, String],
      default: 600
    },
    height: {
      type: [Number, String],
      default: 600
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dragChart: null,
      isChart: false,
      chartHandle: null,
      dataList: [],
      optionData: {},
      loading: false
    }
  },
  watch: {
    apiId() {
      this.loadDataList()
    },
    width() {
      this.setOption()
    },
    height() {
      this.setOption()
    },
    styleChart() {
      this.$nextTick(() => {
        this.dragChart && this.dragChart.resize()
      })
    },
    option: {
      handler() {
        if (this.dragChart && this.isChart) {
          this.setOption()
        }
      },
      deep: true,
      immediate: true
    },
    'option.refresh'(val) {
      if (val) this.loadDataList()
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width:
            this.category === 'report'
              ? this.width || '100%'
              : setPx(this.width),
          height: setPx(this.height),
          background: this.category === 'report' ? '#fff' : 'none'
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleChart() {
      return {
        width:
          this.category === 'report' ? this.width || '100%' : setPx(this.width),
        height: setPx(this.height)
      }
    }
    // minWidth() {
    //   const val = 500
    //   if (val > this.width) return val
    // }
  },
  methods: {
    showColor() {
      if (!this.option.defaultColor) {
        if (this.option.isLinear) {
          return !isEmpty(this.option.colorList)
        } else {
          return !isEmpty(this.option.color)
        }
      } else {
        return false
      }
    },
    getColor(index) {
      if (this.option.defaultColor) return
      if (!this.option.isLinear) return this.option.color[index]
      let list = this.option.colorList || []
      if (list[index]) {
        const color1 = list[index]['color1']
        const color2 = list[index]['color2']
        const postion = (list[index]['position'] || 50) / 100
        if (color2) {
          return {
            type: 'linear',
            x: this.option.showCategory ? 1 : 0,
            y: 0,
            x2: 0,
            y2: this.option.showCategory ? 0 : 1,
            colorStops: [
              {
                offset: 0,
                color: color1
              },
              {
                offset: postion,
                color: color2
              }
            ],
            global: false
          }
        }
        return color1
      }
    },
    getName() {
      if (isEmpty(this.option.column)) return null
      let list = this.option.column.filter((item) => {
        return item.type === 'name'
      })
      return isEmpty(list) ? null : list[0]['prop']
    },
    getValue() {
      if (isEmpty(this.option.column)) return []
      let list = this.option.column.filter((item) => {
        return item.type === 'value'
      })
      return list
    },
    getGroup() {
      if (isEmpty(this.option.column)) return null
      let list = this.option.column.filter((item) => {
        return item.type === 'group'
      })
      return isEmpty(list) ? null : list[0]['prop']
    },
    // 常规图表数据处理
    rendar(resultName, resultValue, categories, series) {
      // series name
      if (!isEmpty(resultValue)) {
        resultValue.forEach((item) => {
          series.push({
            name: item.label || '',
            data: []
          })
          // categories人为的取值label导致柱状图显示不正常，需要字段选择时，设置name
          // if (isEmpty(resultName)) categories.push(item.label)
        })
      }

      this.dataList.forEach((item) => {
        // categories
        if (!isEmpty(resultName)) {
          categories.push(!isEmpty(item[resultName]) ? item[resultName] : '')
        }
        // series value
        if (!isEmpty(series)) {
          for (let i = 0; i < resultValue.length; i++) {
            series[i].data.push({
              // name: !isEmpty(resultName) ? item[resultName] : !isEmpty(categories[i]) ? categories[i] : '',
              name: !isEmpty(resultName) ? item[resultName] : '',
              value: item[resultValue[i]['prop']]
            })
          }
        }
      })
    },
    async loadDataList(conditions) {
      if (!this.apiId) return
      // 参数设置
      let restParams = []
      let query = {}

      // 结果集
      let categories = []
      let series = []
      let indicators = []
      let resultValue = this.getValue()
      let resultName = this.getName()
      let resultGroup = this.getGroup()
      // let len = resultValue.length

      // 过滤条件
      this.option.reqParams.map((item, index) => {
        // 外部条件、参数
        if (!isEmpty(item.key) && !isEmpty(this.$route.query[item.key])) {
          query[item.prop] = this.$route.query[item.key]
        }

        // 固定值、登录人等非空查询
        if (!isEmpty(item.value)) {
          query[item.prop] = item.value
        }
      })

      // 关联组件条件变化
      if (!isEmpty(conditions) && conditions.length > 0) {
        conditions.forEach((item) => {
          this.option.reqParams.map((col) => {
            if (item.label === col.key && !isEmpty(item.value)) {
              query[col.prop] = item.value
            }
          })
        })
      }

      // console.log('query=', query, '图表名称=', resultName, '图表数值=', resultValue)

      try {
        this.loading = true
        let res = await this.$http({
          method: this.option.reqMethod,
          url: mock.getUrl(false) + this.apiId,
          data: restParams, // body
          params: query // query
        })
        this.dataList = res.data

        if (!isEmpty(this.dataList)) {
          switch (this.option.type) {
            case 'radar': {
              // indicators
              if (!isEmpty(resultValue)) {
                resultValue.forEach((item) => {
                  indicators.push({
                    name: item.label || item.prop,
                    max: item.max
                  })
                })
              }
              // series value
              this.dataList.forEach((item, index) => {
                series.push({
                  name: !isEmpty(resultName) ? item[resultName] : '',
                  value: []
                })
                if (!isEmpty(resultValue)) {
                  resultValue.forEach((el) => {
                    series[index]['value'].push(item[el.prop])
                  })
                }
              })
              break
            }
            case 'gauge': {
              // series 1条数据或者json
              let json = Array.isArray(this.dataList)
                ? this.dataList[0]
                : this.dataList
              if (!isEmpty(resultValue)) {
                series.push({
                  name: resultValue[0]['label'],
                  value: json[resultValue[0]['prop']]
                })
              }
              break
            }
            case 'pie':
            case 'funnel': {
              // 图表、漏斗图可能返回一条数据
              if (this.dataList.length === 1) {
                let json = this.dataList[0]
                series.push({
                  name: '',
                  data: []
                })
                if (!isEmpty(resultValue)) {
                  resultValue.forEach((item) => {
                    categories.push(item.label || '')
                    series[0]['data'].push({
                      name: item.label || '',
                      value: json[item.prop] || 0
                    })
                  })
                }
              } else {
                this.rendar(resultName, resultValue, categories, series)
              }
              break
            }
            case 'bar': {
              if (isEmpty(resultGroup)) {
                this.rendar(resultName, resultValue, categories, series)
              } else {
                let list = lodash.sortBy(this.dataList, (item) => {
                  return item[resultName]
                })
                // console.log('测试数据', this.dataList, list)
                categories.push('product')
                list.forEach((item) => {
                  let temp = {}
                  temp.product = item[resultName]
                  temp[item[resultGroup]] = item[resultValue[0]['prop']]
                  series.push(temp)
                  categories.push(item[resultGroup])
                })
              }
              break
            }
            default: {
              this.rendar(resultName, resultValue, categories, series)
            }
          }
        } else {
          categories = []
          series = []
          indicators = []
        }

        this.optionData = {
          categories: categories,
          series: series,
          indicators: indicators
        }

        // console.log('optionData==', this.optionData)
        this.setOption()
        this.onRefresh()
        this.onEchartEvent()
      } catch (err) {
        this.$message.error(err.msg)
      } finally {
        this.loading = false
        this.option.refresh = false
      }
    },
    onRefresh() {
      this.chartHandle && clearInterval(this.chartHandle)
      this.chartHandle = null
      if (this.option.refreshTime > 0 && this.disabled) {
        this.chartHandle = setInterval(() => {
          this.loadDataList()
        }, this.option.refreshTime)
      }
    },
    onEchartEvent() {
      let self = this
      this.dragChart.on('click', (params) => {
        self.dataList.forEach((item) => {
          if (item[this.getName()] === params.name) {
            // 跳转链接
            let url = getTextByAnalysis(self.option.url, item)
            if (isEmpty(url)) return
            if (url.includes('http')) {
              window.open(url, '_blank')
            } else {
              this.$router.push(url)
            }
          }
        })
      })
    },
    init(series = [], categories = [], indicators = []) {
      const dom = this.$refs[this.id]
      const container = this.$refs.container
      if (dom) {
        this.category === 'report' && fixChromeZoom(container)
        this.dragChart = window.echarts.init(dom)
        if (isEmpty(this.apiId)) {
          this.optionData = {
            categories: categories,
            indicators: indicators,
            series: series,
            max: 100,
            map: '',
            location: []
          }
          this.setOption()
        }
      }
    }
  },
  created() {
    this.loadDataList()
  },
  beforeDestroy() {
    clearInterval(this.chartHandle)
  }
}
